import 'flickity/dist/flickity.css'

import Flickity from 'flickity'
export default Flickity

import './page-dots.scss'
